/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the PackageResponse interface.
 */
export function instanceOfPackageResponse(value) {
    if (!('amountCents' in value) || value['amountCents'] === undefined)
        return false;
    if (!('currency' in value) || value['currency'] === undefined)
        return false;
    if (!('generations' in value) || value['generations'] === undefined)
        return false;
    if (!('id' in value) || value['id'] === undefined)
        return false;
    return true;
}
export function PackageResponseFromJSON(json) {
    return PackageResponseFromJSONTyped(json, false);
}
export function PackageResponseFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'amountCents': json['amount_cents'],
        'currency': json['currency'],
        'generations': json['generations'],
        'id': json['id'],
    };
}
export function PackageResponseToJSON(json) {
    return PackageResponseToJSONTyped(json, false);
}
export function PackageResponseToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'amount_cents': value['amountCents'],
        'currency': value['currency'],
        'generations': value['generations'],
        'id': value['id'],
    };
}
